import axios from 'axios';

const apiPS = axios.create({
    //baseURL: "https://ws.pagseguro.uol.com.br/v2",
    baseURL: "https://ws.sandbox.pagseguro.uol.com.br/v2",
});

export default apiPS;